<script setup lang="ts">
import { computed } from 'vue'
import type { HeroImage } from './types'

const props = defineProps<{ logo: HeroImage; name: string }>()
const symbolStyle = computed(() => ({ width: `var(--site-symbol-width, ${props.logo.width ?? 40}px)` }))
</script>

<template>
  <span class="site-brand-symbol">
    <img :src="logo.src" alt="" :style="symbolStyle" class="site-brand-symbol__image" />
    <span class="site-brand-symbol__wordmark">{{ name }}</span>
  </span>
</template>

<style scoped>
.site-brand-symbol {
  display: inline-flex;
  flex-direction: var(--site-logo-direction, row);
  align-items: center;
  gap: 0.6rem;
  max-width: 100%;
}
.site-brand-symbol__image { height: auto; max-width: 100%; flex-shrink: 0; object-fit: contain; }
.site-brand-symbol__wordmark { font-family: var(--site-font-wordmark, var(--site-font-heading)); overflow-wrap: anywhere; }
</style>
